module.exports = __webpack_public_path__ + "img/user-white.690aba58.svg";